import Language from './Constants/Language';

class Track {
    public index: number = -1;
    public language: Language = Language.NONE;
    public label: string = '';
    public isActive: boolean = false;
}

export default Track;